// ===== ORÇAMENTO — abas, workspace guiado de ambientes/peças, descrição automática, revisão =====
let _pedOrcTabAtiva=0;
let _pedViewMode='guiado';
let _pedAmbAtivo=null;
let _pedItemAtivo=null;
let _pedDescAutoLast='';
let _pedDescManual=false;
let _pedDescListenerBound=false;
let _pedRevisaoTemImpeditivo=false;

function switchOrcTab(idx){
  _pedOrcTabAtiva=idx;
  document.querySelectorAll('.orc-tab').forEach((t,i)=>{
    const active=i===idx;
    t.style.color=active?'var(--accent)':'var(--muted)';
    t.style.borderBottom=active?'2px solid var(--accent)':'2px solid transparent';
    t.style.fontWeight=active?'600':'500';
  });
  document.querySelectorAll('.orc-panel').forEach((p,i)=>p.style.display=i===idx?'':'none');
  if(idx===1)atualizarOrcamentoUI();
  if(idx===3)renderRevisaoOrcamento();
  renderOrcFooterPrimary(idx);
}
function renderOrcFooterPrimary(idx){
  const wrap=document.getElementById('p-save-btn-wrap');if(!wrap)return;
  if(idx===2)wrap.innerHTML='<button class="btn btn-primary" onclick="avancarOrcamentoTab()">Salvar e revisar →</button>';
  else if(idx===3)wrap.innerHTML='<button class="btn btn-ghost" onclick="salvarPedido()">Salvar orçamento</button> <button class="btn btn-primary" onclick="enviarOrcamentoParaAprovacao()">Enviar para aprovação</button>';
  else wrap.innerHTML='<button class="btn btn-primary" onclick="avancarOrcamentoTab()">Salvar e avançar →</button>';
}
function setOrcViewMode(mode){
  _pedViewMode=mode;
  const guiado=document.getElementById('orc-view-guiado'),tabela=document.getElementById('orc-view-tabela');
  const btnGuiado=document.getElementById('orc-view-guiado-btn'),btnTabela=document.getElementById('orc-view-tabela-btn');
  if(guiado)guiado.style.display=mode==='guiado'?'':'none';
  if(tabela)tabela.style.display=mode==='tabela'?'':'none';
  if(btnGuiado)btnGuiado.classList.toggle('btn-ghost',mode!=='guiado');
  if(btnTabela)btnTabela.classList.toggle('btn-ghost',mode!=='tabela');
  if(mode==='guiado')atualizarOrcamentoUI();
  if(document.getElementById('pid')?.value||document.getElementById('p-cliente')?.value.trim())_dispararAutosavePedido();
}
function atualizarOrcamentoUI(){
  renderContextoSidebar();
  renderChipsAmbientes();
  renderListaPecasAmbiente();
  renderPainelPeca();
  atualizarDescricaoAutomatica();
  if(_pedOrcTabAtiva===3)renderRevisaoOrcamento();
}
function renderContextoSidebar(){
  const el=document.getElementById('orc-context-sidebar');if(!el)return;
  const g=id=>document.getElementById(id)?.value||'';
  const linha=(label,val)=>`<div class="orc-ctx-row" title="${escapeHtml(`${label}: ${val||'—'}`)}"><span>${escapeHtml(label)}</span><span>${escapeHtml(val)||'—'}</span></div>`;
  el.innerHTML=`
    <section class="orc-context-group"><h4>Cliente</h4>
      ${linha('Nome',g('p-cliente'))}
      ${linha('Telefone',g('p-tel'))}
      ${linha('E-mail',g('p-email'))}
      ${linha('CPF/CNPJ',g('p-cpfcnpj'))}
      ${linha('Canal',g('p-origem'))}
    </section>
    <section class="orc-context-group"><h4>Obra</h4>
      ${linha('Endereço',[g('p-end'),g('p-num-end')].filter(Boolean).join(', '))}
      ${linha('Bairro',g('p-bairro'))}
      ${linha('CEP',g('p-cep'))}
      ${linha('Complemento',g('p-comp-end'))}
    </section>
    <section class="orc-context-group"><h4>Orçamento</h4>
      ${linha('Origem técnica',BASES_ORCAMENTO[g('p-base-orcamento')]?.label||'')}
      ${linha('Responsável',g('p-resp-informacao'))}
      ${linha('Confiança',g('p-confianca-medida'))}
      ${linha('Documento',g('p-documento-base'))}
    </section>
  `;
}
function nomesAmbientesAtuais(){
  const temGeral=_pedItens.some(it=>!String(it.ambiente||'').trim());
  return [...(temGeral?['']:[]),...new Set([..._pedAmbList,..._pedItens.map(it=>String(it.ambiente||'').trim()).filter(Boolean)])];
}
// Aplica _pedAmbOrdem sobre o conjunto real de ambientes: remove da ordem quem não
// existe mais, acrescenta no fim quem ainda não tinha posição definida (ambiente
// recém-criado). Sincroniza _pedAmbOrdem para o resultado, então chamadas
// seguintes já partem da ordem estável.
// _pedAmbOrdem guarda {id,nome} (revisão técnica 2026-08-12: usar id estável em
// vez de string de nome — sobrevive a rename sem perder posição; ver
// renomearPedidoAmbiente). ambientesOrdenados() continua devolvendo string[] de
// nomes: é o contrato que renderChipsAmbientes/pecasDoAmbiente já usam, e mudar
// isso exigiria tocar o módulo de medição (_medAmbientes), que também é
// name-based e está fora do escopo desta spec.
function ambientesOrdenados(){
  const validos=nomesAmbientesAtuais(),validosSet=new Set(validos);
  const ordenados=_pedAmbOrdem.filter(a=>validosSet.has(a.nome));
  validos.forEach(nome=>{if(!ordenados.some(a=>a.nome===nome))ordenados.push({id:uid(),nome})});
  _pedAmbOrdem=ordenados;
  return ordenados.map(a=>a.nome);
}
function ambienteDragStart(e,idx){
  _pedAmbDragIdx=idx;
  e.dataTransfer.effectAllowed='move';
  e.currentTarget.style.opacity='0.4';
}
function ambienteDragEnd(e){
  e.currentTarget.style.opacity='';
  _pedAmbDragIdx=null;
}
function ambienteDrop(e,targetIdx){
  e.preventDefault();
  if(_pedAmbDragIdx==null||_pedAmbDragIdx===targetIdx)return;
  ambientesOrdenados(); // garante _pedAmbOrdem sincronizado com os ambientes atuais antes de reordenar
  const [item]=_pedAmbOrdem.splice(_pedAmbDragIdx,1);
  _pedAmbOrdem.splice(targetIdx,0,item);
  _pedAmbDragIdx=null;
  renderChipsAmbientes();
  _dispararAutosavePedido();
}
function renderChipsAmbientes(){
  const el=document.getElementById('orc-chips-ambientes');if(!el)return;
  const nomes=ambientesOrdenados();
  if(_pedAmbAtivo==null&&nomes.length)_pedAmbAtivo=nomes[0];
  if(_pedAmbAtivo!=null&&!nomes.includes(_pedAmbAtivo))_pedAmbAtivo=nomes.length?nomes[0]:null;
  el.innerHTML=nomes.map((nome,idx)=>{
    const pecas=pecasDoAmbiente(nome);
    const m2=pecas.reduce((s,x)=>s+(x.it._m2||0),0);
    const ativo=nome===_pedAmbAtivo;
    const label=nome||'Geral';
    return `<div class="orc-chip${ativo?' active':''}" draggable="true" ondragstart="ambienteDragStart(event,${idx})" ondragend="ambienteDragEnd(event)" ondragover="event.preventDefault()" ondrop="ambienteDrop(event,${idx})" data-ambiente="${escapeHtml(nome)}" role="button" tabindex="0" aria-pressed="${ativo}" aria-label="${escapeHtml(label)}: ${pecas.length} peça(s), ${m2.toFixed(2)} metros quadrados">
      <span class="orc-chip-drag-handle" aria-hidden="true" title="Arraste para reordenar">⠿</span>
      <span class="orc-chip-content">${escapeHtml(label)}<br><small>${pecas.length} peça(s) · ${m2.toFixed(2)} m²</small></span>
      <span class="orc-chip-actions">${ativo&&nome?`<button type="button" class="orc-chip-rename-btn" data-action="renomear-ambiente" data-ambiente="${escapeHtml(nome)}" title="Renomear ambiente">✎</button><button type="button" data-action="duplicar-ambiente" data-ambiente="${escapeHtml(nome)}" title="Duplicar ambiente (cópia independente, com todas as peças)">⧉</button><button type="button" data-action="remover-ambiente" data-ambiente="${escapeHtml(nome)}" title="Remover ambiente">×</button>`:''}</span>
    </div>`;
  }).join('')+`<div class="orc-chip orc-chip-add" data-action="novo-ambiente" role="button" tabindex="0">+ Novo ambiente</div>`;
}
